module.exports = __webpack_public_path__ + "img/mauro1.f0c75f33.jpg";